export enum StockListFilter {
  ALL_CAGE = 'ALL_CAGE',
  EMPTY_CAGE = 'EMPTY_CAGE',
  ALL_MOTHER = 'ALL_MOTHER',
  CAGELESS_MOTHER = 'CAGELESS_MOTHER',
}
